import React, { useState } from 'react';
import ExcelJS from 'exceljs';
import {
  formatPrice,
  KTSVG,
  LoadingGrid,
  TableList,
} from '../../../../../rbts/helpers';
import Select from 'react-select';
import {
  useObtenerDiasPorEvento,
  useReporteCortesias,
} from '../hooks/CortesiasHook';
import { styleSelect } from '../../../../../rbts/assets/ts/_utils';

type Props = {};

const Vista: React.FC<Props> = ({}) => {
  const [diaSeleccionado, setDiaSeleccionado] = useState<any | null>([]);
  const [idDia, setIdDia] = useState<number>(0);
  const [reloadInfo, setReloadInfo] = useState<number>(Math.random() * 40);
  const { list, saldoElectronico, loadingRequest } = useReporteCortesias(
    reloadInfo,
    idDia
  );
  const { list: listadosDeDias, loadingRequest: cargandoDias } =
    useObtenerDiasPorEvento(reloadInfo);

  const columns: any = [
    {
      id: 'ticket',
      name: <div className="fw-bolder text-muted me-5">Folio de ticket:</div>,
      selector: (row: any) => row.ticket.folio,
      cell: (row: any) => (
        <>
          <span className="fw-bolder ">{row.ticket.folio}</span>
        </>
      ),
      sortable: false,
    },
    {
      id: 'cliente',
      name: <div className="fw-bolder text-muted me-5">Cliente</div>,
      selector: (row: any) => row.ticket.cliente.nombre,
      cell: (row: any) => (
        <>
          <span>{row.ticket.cliente.nombre}</span>
        </>
      ),
      sortable: false,
    },
    {
      id: 'monto',
      name: <div className="fw-bolder text-muted me-5 ">Monto</div>,
      selector: (row: any) => row.monto,
      cell: (row: any) => (
        <>
          <div className="fw-bolder">
            {formatPrice(row.monto ? row.monto : 0, 'es-MX', 'MXN', 2, 2)}
          </div>
        </>
      ),
      sortable: false,
    },
  ];

  // DESCARGA EXCEL

  const [loadingDownload, setLoadingDownload] = React.useState(false);
  const columnsExcel: any = ['Ticket', 'Cliente', 'Monto'];
  const handleDownloadExcel = async () => {
    setLoadingDownload(true);
    try {
      await exportTableToExcel(
        list,
        columnsExcel,
        `reporte_cortesias_${diaSeleccionado.label}.xlsx`
      );
    } catch (error) {
      console.error('Error downloading Excel:', error);
    } finally {
      setLoadingDownload(false);
    }
  };

  const exportTableToExcel = async (
    data: any[],
    columns: string[],
    filename = 'tabla.xlsx'
  ) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(
      `Cortesías ${diaSeleccionado.label}`
    );
    worksheet.columns = [
      { header: 'Ticket', key: 'ticket', width: 30 },
      { header: 'Cliente', key: 'cliente', width: 20 },
      { header: 'Monto', key: 'monto', width: 30 },
    ];
    let totalMonto = 0;

    data.forEach((item) => {
      const monto = Number(item.monto);
      totalMonto += monto;

      worksheet.addRow([item.ticket.folio, item.ticket.cliente.nombre, monto]);
    });

    // Agregar una fila vacía para separar visualmente
    worksheet.addRow([]);

    // Agregar la fila de total
    worksheet.addRow(['', 'Total', totalMonto]);
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const handleSupplierOnChange = (selectedOption: any) => {
    if (selectedOption) {
      setDiaSeleccionado(selectedOption);
      setIdDia(selectedOption.id);
    } else {
      setDiaSeleccionado(null);
      setIdDia(0);
    }
  };

  return (
    <>
      <div className="d-flex flex-column flex-xl-row">
        <div className="col-xl-12">
          <div className="card mb-6 mb-xl-9">
            <div className="card-header border-0 pt-5">
              <div className="card-title">
                <div className="w-300px pe-5 fs-7 text-gray-700">
                  <div className="w-100 d-flex">
                    <label className="form-label w-auto">
                      Día administrativo:{' '}
                    </label>
                  </div>
                  <Select
                    options={listadosDeDias}
                    value={diaSeleccionado}
                    styles={styleSelect}
                    placeholder={'Seleccione'}
                    className="w-100"
                    isSearchable={true}
                    noOptionsMessage={() => {
                      return <span>{'No se encontraron registros'}</span>;
                    }}
                    onChange={handleSupplierOnChange}
                    isLoading={loadingRequest}
                    isClearable
                    backspaceRemovesValue
                  />
                </div>
              </div>
              <div className="card-toolbar">
                <div className="d-flex rounded mt-3">
                  {list.length > 0 && (
                    <button
                      className="btn btn-sm btn-light-success"
                      disabled={loadingDownload}
                      onClick={() => handleDownloadExcel()}
                    >
                      {loadingDownload ? (
                        <span
                          className="indicator-progress"
                          style={{ display: 'block' }}
                        >
                          Descargando...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      ) : (
                        <>
                          {/* <KTSVG
                            path="/media/icons/duotune/files/fil030.svg"
                            className="svg-icon-5 svg-icon-gray-500 me-3"
                          /> */}
                          Descargar
                        </>
                      )}
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className="card-body">
              {list.length > 0 && (
                <div className="row gy-5 g-xl-8">
                  <div className="col-xl-12">
                    <div className="d-flex flex-column flex-sm-row align-items-start justify-content-between">
                      <div className="d-flex align-items-center mb-5 ms-1">
                        <div className="text-gray-800 fw-bold fs-6 me-5 ">
                          Saldo total:
                        </div>
                        <span className=" fw-bolder fs-5 text-gray-800">
                          {formatPrice(saldoElectronico, 'es-MX', 'MXN', 2, 2)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="row gy-5 g-xl-8">
                <div className="col-xl-12">
                  {loadingRequest ? (
                    <LoadingGrid text="Cargando..."></LoadingGrid>
                  ) : (
                    <>
                      <TableList data={list} columns={columns}></TableList>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { Vista };
